/** @jsx jsx */

import { jsx, Link } from "theme-ui";
import useMyBoolean from "sites-common/hooks/useMyBoolean";
import PropTypes from "prop-types";
import { Icon } from "office-ui-fabric-react";
import UploadFile from "./UploadFile";
import { useLang } from "./LanguageSelector";
import { IkonButton, IkonTextButton } from "../StyledButtons";

const { shade5, shade0, good, danger } = require("./json/colors.json");

const { collection, storagepath } = require("./json/firebase.json");

// const onDiscard = noop;
function EditAttachment({
  uid,
  dbKey,
  docId,
  dbField,
  uploadBtnText,
  strClick,
  locked,
}) {
  const [open, { setTrue, setFalse }] = useMyBoolean(false);
  const [getLangString] = useLang();

  if (!open) {
    if (dbField) {
      return (
        <div>
          {uid ? (
            <Link
              target="_blank"
              title={dbField.fileName}
              href={dbField.downloadURL}
            >
              <Icon iconName="Accept" />
              {uid ? getLangString("strings.uploaded") : ""}
            </Link>
          ) : (
            <IkonButton
              color={shade0}
              background={good}
              iconProps={{ iconName: "Accept" }}
              title={dbField.fileName}
              href={dbField.downloadURL}
              target="_blank"
            />
          )}
          <IkonButton
            color={shade0}
            background="transparent"
            iconProps={{ iconName: "Edit" }}
            title={getLangString("strings.change_file")}
            onClick={setTrue}
            disabled={locked}
          />
        </div>
      );
    }

    return (
      <div>
        {!uid ? (
          <IkonButton
            color={shade0}
            background={danger}
            iconProps={{ iconName: "Warning12" }}
            title={getLangString("strings.upload_file")}
            onClick={setTrue}
          />
        ) : (
          <IkonTextButton
            color={shade0}
            background={shade5}
            iconName="Upload"
            text={getLangString(uploadBtnText || "strings.upload_file")}
            title={getLangString("strings.upload_file")}
            onClick={setTrue}
            disabled={locked}
          />
        )}
      </div>
    );
  }

  return (
    <UploadFile
      dbKey={dbKey}
      filesPath={`${storagepath}/artefacts/${uid}`}
      dbPath={`${collection}`}
      docId={docId}
      onUpload={setFalse}
      onDiscard={setFalse}
      strClick={strClick}
    />
  );
}

EditAttachment.propTypes = {
  uid: PropTypes.string.isRequired,
  docId: PropTypes.string.isRequired,
  dbKey: PropTypes.string.isRequired,
  dbField: PropTypes.shape({
    fileName: PropTypes.string,
    downloadURL: PropTypes.string,
  }).isRequired,
  uploadBtnText: PropTypes.string,
  strClick: PropTypes.string,
  locked: PropTypes.bool,
};
EditAttachment.defaultProps = {
  uploadBtnText: undefined,
  strClick: undefined,
  locked: false,
};

export default EditAttachment;
